export const supplierHotelStopSaleViewModelStructure = {
    Enabled: true,
    FromDate: true,
    Id: true,
    IdHotel: true,
    IdHotelOwner: true,
    IdSupplierHotel: true,
    IdSupplierHotelMealPlan: true,
    IdSupplierHotelRatePlan: true,
    IdSupplierHotelRoomType: true,
    ToDate: true,
};
